// extracted by mini-css-extract-plugin
module.exports = {"b1ruwqcb":"b1ruwqcb","c1paep96":"c1paep96"};